import { useCallback, useMemo, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import UF from 'utils/getUF';
import { IState } from 'store';
import { objectIsEmpty } from 'utils/objectEmpty';
import { IUserProps } from 'store/modules/profile';
import { setUF, IUFProps } from 'store/modules/config';

import { SimpleSelect } from 'components/common/Select/SimpleSelect';

import * as S from './styles';

interface IModalChangeState {
  setShowModalChangeState(state: boolean): void;
}

export default function ModalChangeState({
  setShowModalChangeState,
}: IModalChangeState) {
  const dispatch = useDispatch();

  const ufSelected = useSelector<IState, IUFProps>(state => state.config.uf);
  const user = useSelector<IState, IUserProps>(state => state.profile.user);

  const [selectValue, setSelectValue] = useState<any>();

  const ufs = useMemo(() => {
    return UF;
  }, []);

  const handleSelectState = useCallback(() => {
    dispatch(setUF(selectValue));
    setShowModalChangeState(false);
  }, [dispatch, selectValue, setShowModalChangeState]);

  return (
    <S.Container className="modal-change-state">
      <h4>Informe o estado</h4>

      <div className="modal-change-state-content">
        {objectIsEmpty(user) && (
          <span className="modal-change-state-message">
            Atenção! Você está visualizando os preços do Estado referente ao
            endereço de seu cadastro, caso mude a consulta para outra região, os
            produtos de seu carrinho permanecerão com o preço do seu endereço.
          </span>
        )}

        <div>
          <SimpleSelect
            name="state"
            options={ufs}
            defaultValue={
              ufSelected ? ufSelected : { value: 'SP', label: 'São Paulo' }
            }
            setSelectValue={setSelectValue}
            isSearchable
          />

          <button className="modal-button" onClick={handleSelectState}>
            Alterar
          </button>
        </div>
      </div>
    </S.Container>
  );
}
